import * as React from "react";
import {
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
  Button,
  Avatar,
} from "@mui/material";
import { Colors } from "../../utils/Colors";

function getStatusStyles(status) {
  if (status === "Critical") {
    return {
      color: Colors.status.danger,
      borderColor: Colors.status.danger,
      bgcolor: "rgba(239,68,68,0.08)",
    };
  }
  if (status === "Under Review") {
    return {
      color: Colors.status.warning,
      borderColor: Colors.status.warning,
      bgcolor: "rgba(245,158,11,0.08)",
    };
  }
  return {
    color: Colors.status.success,
    borderColor: Colors.status.success,
    bgcolor: "rgba(34,197,94,0.08)",
  };
}

export default function DoctorPatientCard({ patient }) {
  const badge = getStatusStyles(patient.status);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 4,
        border: `1px solid ${Colors.border.light}`,
        bgcolor: Colors.bg.paper,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar sx={{ bgcolor: Colors.brand.primary }}>
            {patient.name?.charAt(0) || "P"}
          </Avatar>

          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 700, color: Colors.text.title }}
            >
              {patient.name}
            </Typography>
            <Typography variant="body2" sx={{ color: Colors.text.muted }}>
              UHID: {patient.uhid} | Age: {patient.age} | Ward: {patient.ward}
            </Typography>
            <Typography variant="body2" sx={{ color: Colors.text.sub, mt: 0.5 }}>
              Diagnosis: {patient.diagnosis}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Chip
            label={patient.status}
            variant="outlined"
            sx={{
              fontWeight: 700,
              color: badge.color,
              borderColor: badge.borderColor,
              bgcolor: badge.bgcolor,
            }}
          />
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: 3,
              bgcolor: Colors.brand.primary,
              "&:hover": {
                bgcolor: Colors.brand.primaryDark,
              },
            }}
          >
            View Profile
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}